import React, { FunctionComponent, useEffect } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import FormInput from "../../components/Form/Inputs/FormInput"
import SelectInput, {
  FormSelectInput,
} from "../../components/Form/Select/Select"
import { iExhibitionQuery } from "../../definitions/Exhibition"
import { iChangeType } from "../../definitions/interfaces"
import { isAdmin } from "../../helpers/isAdmin"
import s from "./Exhibitions.less"

interface iProps {
  setQuery: (data: iExhibitionQuery, resetQuery?: boolean) => void
  query: iExhibitionQuery
}

const ExhibitionFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  const methods = useForm({
    defaultValues: {
      ...query,
    },
  })

  return (
    <div className={`filters ${s.filters}`}>
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            placeholder="Title..."
            autoComplete="off"
            name={"title"}
            onChange={onChange}
          />
          <FormInput
            autoComplete="off"
            placeholder="Subtitle..."
            name={"subtitle"}
            onChange={onChange}
          />
          <Controller
            name="published"
            control={methods.control}
            render={({ value, onChange: formOnChange }) => {
              console.log(value)

              return (
                <SelectInput
                  name={"published"}
                  onChange={(value) => {
                    formOnChange(value)
                    onChange({ name: "published", value })
                  }}
                  isClearable={true}
                  options={[
                    { label: "Draft", value: "DRAFT" },
                    { label: "Published", value: "PUBLISHED" },
                  ]}
                  value={value}
                />
              )
            }}
          />

          {isAdmin() && (
            <>
              <FormSelectInput
                name="orderBy"
                placeholder="Order by"
                onChange={(value) => {
                  setQuery({
                    ["orderBy"]: value.orderBy,
                    ["order"]: value.order as number,
                  })
                }}
                options={[
                  {
                    label: "Title (A -> Z)",
                    value: { orderBy: "title", order: 1 },
                  },
                  {
                    label: "Title (Z -> A)",
                    value: { orderBy: "title", order: -1 },
                  },
                  {
                    label: "Date Created (Newest -> Oldest)",
                    value: { orderBy: "createdAt", order: -1 },
                  },
                  {
                    label: "Date Created (Oldest -> Newest)",
                    value: { orderBy: "createdAt", order: 1 },
                  },
                ]}
              />

              <FormInput
                autoComplete="off"
                name="public"
                type="checkbox"
                label="Show public"
                onChange={onChange}
              />
            </>
          )}
        </FormProvider>
      </div>
    </div>
  )
}

export default ExhibitionFilters
